import { useTranslation } from "react-i18next";
import { FrontendUserInfo } from "node-library/dist/portal";
import ViewUsersTable from "./viewUsersTable";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	users: Array<FrontendUserInfo>;
	goToViewUserDetails: (user: FrontendUserInfo) => void;
	setDeleteUserConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function RosterUserContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		users,
		goToViewUserDetails,
		setDeleteUserConfirmOpen,
		setProceedAction,
	} = props;

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{users.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div
						className="typography-heading-01"
						style={{ marginTop: "20px", color: NeutralColor.NEUTRAL_GREY_300 }}
					>
						{translation("NoUsers")}
					</div>
				</div>
			) : (
				<div>
					<ViewUsersTable
						users={users}
						goToViewUserDetails={goToViewUserDetails}
						setDeleteUserConfirmOpen={setDeleteUserConfirmOpen}
						setProceedAction={setProceedAction}
					/>
				</div>
			)}
		</div>
	);
}
